import { parseAgentMessage } from "@/utils";
import type { ChatPreset } from "@/types";
import { basePreset } from "../base";
import { composeChatPresets, defineChatPreset } from "../define";
import {
  xGroupMarkdownResourceLinkSchemes,
  xGroupToolKindResolver,
} from "./strategies";
import { xGroupMarkdownExtensions } from "./knowledgeReference";
import { createXGroupUploadRequest } from "./upload";

/** 众安信科 ADK 官方预设：聚合工具展示、消息解析、确认响应和默认上传等业务策略。 */
export const xGroupAdkPreset: ChatPreset = composeChatPresets(
  basePreset,
  defineChatPreset({
    name: "xgroup-adk",
    markdownExtensions: xGroupMarkdownExtensions,
    strategies: {
      resolveToolKind: xGroupToolKindResolver,
      parseProcessMessage: (text, options) =>
        parseAgentMessage(text, { mode: "comment", ...options }),
      markdownResourceLinkSchemes: xGroupMarkdownResourceLinkSchemes,
    },
    createUploadRequest: createXGroupUploadRequest,
  }),
);
